import StickyJs from 'sticky-js';

document.addEventListener('turbolinks:load', () => {
  const sticky = new StickyJs('.js-sticky');
});
